import translations from "../../../../translations/resources/en-GB.json";
export var CONFIRM_DAILOG_HEADER = translations.data["venonboard.updateMapOrder.placeOrder"];
export var CONFIRM_DAILOG_TEXT = translations.data["venonboard.updateMapOrder.Headline"];
export var SUBMIT_DIALOG_NOTIFICATION_TEXT = translations.data["venonboard.annotationSubmit.notificationText"];
export var ANNOTATION_ORDER_NOTIFICATION = {
    SUCCESS: {
        TITLE: translations.data["venonboard.annotationSubmit.success.title"],
        BODY: translations.data["venonboard.annotationSubmit.success.body"],
    },
    FAILURE: {
        TITLE: translations.data["venonboard.annotationSubmit.failure.title"],
        BODY: translations.data["venonboard.annotationSubmit.failure.body"],
    },
    ATTACHMENT_FAILURE: {
        TITLE: translations.data["venonboard.annotationAttachment.failure.title"],
        BODY: translations.data["venonboard.annotationAttachment.failure.body"],
    },
};
export var discardIconStyle = {
    "--hds-icon-color": "var(--hds-negative)",
    display: "flex",
};
export var FLOOR_PLANS_DESCRIPTION_PLACEHOLDER = translations.data["venonboard.annotationEntryScreen.uploadFloorPlans.description.placeholder"];
export var commonDivStyles = {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
};
export var discardButtonStyles = {
    display: "flex",
    gap: "10px",
    alignItems: "center",
};
